module.exports = __webpack_public_path__ + "static/media/zoology_banner_small.10588f65.png";